/* -----------------Child components--------------- */
import { CustomAppbar } from "components/index";

import { appBarMeta } from "@constants/appbar";
import { pageViewTypes } from "@constants/tracking";
/* -----------------Features--------------- */
import { LeaderboardContainer } from "@features/dashboard";
import { isWeb } from "@helpers/platform";
import useAnalytics from "@hooks/useAnalytics";
import { useDevice } from "@hooks/useDevice";
import DocumentTitle from "components/DocumentTitle";
import { useTranslation } from "react-i18next";

const LeaderboardRoute = () => {
	const { t } = useTranslation();
	const { isMobile } = useDevice();
	useAnalytics({
		type: pageViewTypes.leaderboard,
	});
	return (
		<>
			<CustomAppbar
				showCommandBar={isWeb}
				showHambugerMenu
				options={{
					headerTitle: t(appBarMeta.leaderboard.title),
					subtitle: isMobile ? "" : t(appBarMeta.leaderboard.description),
				}}
			/>
			<DocumentTitle title={t(appBarMeta.leaderboard.title)} />
			<LeaderboardContainer />
		</>
	);
};

export default LeaderboardRoute;
